import { apiSlice } from "../api/apiSlice";

export const usersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query({
      query: (email) => `/users?email=${email}`,
    }),
    getSuggestedUser: builder.query({
      query: (arg) => `/users`,
      transformResponse(apiResponse) {
        //   let exisitingMembers = arg.teamMembers.map((m) => m.email);
        return apiResponse.map((r) => {
          return { id: r.id, name: r.name, email: r.email, userUrl: r.userUrl };
        });
      },
    }),
  }),
});

export const { useGetUserQuery, useGetSuggestedUserQuery } = usersApi;
